export default __webpack_public_path__ + "static/media/KZ.M.16.2210.eb24cf73.svg";